import React, { type DetailedHTMLProps, type FC } from 'react';
import styled from '@emotion/styled';

const Button = styled.button(
  {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: '0'
  },
  (props) => ({
    cursor: props.disabled ? 'not-allowed' : 'pointer'
  })
);

const UnstyledButton: FC<DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>> = ({
  type = 'button',
  'data-testid': dataTestId = 'unstyled-button',
  ...rest
}) => <Button type={type} {...rest} data-testid={dataTestId} />;

export default UnstyledButton;
